<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Fiducia</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/fiducia">
            <CIcon name="cil-book" />
            Fiducia
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow class="mx-2">
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data Kontrak</h5>
              </CCol>
              <CCol class="col-12 pt-2 custom-detail-list">
                <CRow v-if="isLoading">
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tipe Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ details.contractType == "R" ? "Roya" : "Fiducia" }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.contractNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Cabang</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.officeName, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Status</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.contractStatus, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.contractDate, "shortDate") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Notaris</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.notaryName, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Penugasan</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.assignmentDate, "shortDate") }}</p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data Customer</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="pt-2 custom-detail-list">
                <CRow v-if="isLoading">
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>Nama</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.customerName, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>Alamat</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.customerAddress, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>Tanggal Lahir</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.customerDob, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>No. KTP</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.customerKtp, "string") }}</p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                <h5 class="custom-header-display">Dokumen Fiducia</h5>
                <h6 class="mb-0" v-if="isLoading"><Skeleton type="rect" :width="'10rem'" :height="'1.69rem'" animation="fade" /></h6>
                <h6 v-else-if="details.documentStatus == 'Y'" class="custom-text-blue">Status Validasi - Y</h6>
                <h6 v-else>Status Validasi - N</h6>
              </CCol>
              <template v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])">
                <CCol class="col-4 col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2  offset-1 offset-xs-1 offset-sm-1 offset-md-2 offset-lg-2 offset-xl-4" v-if="isLoading">
                  <Skeleton type="rect" :width="'100%'" :height="'2.38rem'" animation="fade" />
                </CCol>
                <CCol class="col-5 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-6" v-else>
                  <CButton color="primary" class="float-right" @click="showAddDocumentModal()" v-if="$helper.isRole($availRoles['Cabang'])">
                    Add <FaIcon icon="plus" />
                  </CButton>
<!--                   <CButton color="primary" class="float-right mr-2" @click="showReGenerateDocumentModal()">
                    Re-Generate <CIcon name="cil-reload" />
                  </CButton> -->
                </CCol>
              </template>
              <CCol class="col-12 pt-2 custom-detail-list">
                <template v-if="isLoading">
                  <CRow v-for="index in 5" :key="index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6 mb-1" v-if="($helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris']))">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-12 mb-1" v-else>
                      <CRow>
                        <CCol class="col-8 col-xs-8 col-sm-6 col-md-5 col-lg-6 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-4 col-xs-4 col-sm-6 col-md-7 col-lg-6 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-5 col-xs-5 col-sm-6 col-md-5 col-lg-5 col-xl-6 text-right mb-1" v-if="($helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris']))">
                      <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                    </CCol>
                  </CRow>
                </template>
                <template v-else>
                  <CRow :class="{custom_row_blue: item.isHovered === true}" v-for="(item, index) in details.listDocument" :key="item.name + '-' + index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6" v-if="($helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris']))">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <p>{{ item.name }}</p>
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <p class="custom-text-blue" v-if="!$helper.isEmpty(item.repositoryId)">Uploaded</p>
                          <p v-else>Not Uploaded</p>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-12" v-else>
                      <CRow>
                        <CCol class="col-8 col-xs-8 col-sm-6 col-md-5 col-lg-6 col-xl-4">
                          <p>{{ item.name }}</p>
                        </CCol>
                        <CCol class="col-4 col-xs-4 col-sm-6 col-md-7 col-lg-6 col-xl-8">
                          <p class="custom-text-blue" v-if="!$helper.isEmpty(item.repositoryId)">Uploaded</p>
                          <p v-else>Not Uploaded</p>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-5 col-xs-5 col-sm-6 col-md-5 col-lg-5 col-xl-6 text-right" v-if="($helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris']))">
                      <b-spinner small v-if="item.isTransferring" />
                      <div style="display:inline" v-else>
                        <span @touchstart="onRowHover(index)" @touchend="onRowLeave(index)" @mouseover="onRowHover(index)" @mouseleave="onRowLeave(index)" class="custom-link-delete" v-if="$helper.isRole($availRoles['Cabang']) && item.id != null" @click="deleteDocument(index)">Delete</span>
                        <span v-if="$helper.isRole($availRoles['Cabang']) && item.id != null"> | </span>
                        <span @touchstart="onRowHover(index)" @touchend="onRowLeave(index)" @mouseover="onRowHover(index)" @mouseleave="onRowLeave(index)" class="custom-link-download" v-if="$helper.isRole($availRoles['Cabang'])" @click="showUploadModal(index)">Upload</span>
                        <span v-if="$helper.isRole($availRoles['Cabang'])"> | </span>
                        <span @touchstart="onRowHover(index)" @touchend="onRowLeave(index)" @mouseover="onRowHover(index)" @mouseleave="onRowLeave(index)" class="custom-link-download" v-if="($helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])) && !$helper.isEmpty(item.repositoryId)" @click="downloadDocument(index)">Download</span>
                        <span class="custom-link-download-disabled" v-if="($helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])) && $helper.isEmpty(item.repositoryId)">Download</span>
                      </div>
                    </CCol>
                    <b-form-file
                      v-model="item.fileUpload"
                      :accept="item.acceptedExtension"
                      :ref="'document-upload-' + index"
                      v-show="false"
                      @input="uploadDocument($event, index)"
                    ></b-form-file>
                  </CRow>
                </template>
              </CCol>
              <CCol class="col-12 mt-4" v-if="!$helper.isEmpty(details.documentNotes)">
                <b-alert show variant="light" class="py-0" style="display:flex;align-items:center">
                  <div><b-icon icon="exclamation-triangle" font-scale="2.5" variant="danger" class="my-1 mr-3"></b-icon></div>
                  <div class="py-2" style="overflow: auto;">{{ details.documentNotes }}</div>
                </b-alert>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                <h5 class="custom-header-display">Daftar Collateral</h5>
              </CCol>
              <CCol class="col-12 pt-2">
                <b-table striped hover show-empty
                  responsive="xl"
                  :items="collateralTable.items"
                  :fields="collateralTable.fields"
                  :busy="!collateralTable.isLoaded"
                  no-local-sorting no-sort-reset
                  head-variant
                >
                  <template #cell(customerBpkbName)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(vehicleCategory)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(vehicleType)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(vehicleEngineNo)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(vehicleFrameNo)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(vehicleNopol)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(vehicleColor)="row">
                    {{ $helper.showData(row.value, "string") }}
                  </template>
                  <template #cell(actionDeed)="row">
                    <b-button class="mr-2" variant="primary" size="sm" style="width:63px" title="Upload Akta" :disabled="row.item.isBusyDeed" @click="showUploadDeedModal(row.index)">
                      <b-spinner small v-if="row.item.isBusyDeed" label="Uploading..."></b-spinner>
                      <span v-else>Upload</span>
                    </b-button>
                    <CButton class="mr-2" color="primary" variant="outline" size="sm" style="width:81px" :title="$helper.isEmpty(row.item.aktaFiduciaFileId) ? 'Deed unavailable' : 'Download Akta'" :disabled="$helper.isEmpty(row.item.aktaFiduciaFileId) || row.item.isBusyDeed" @click="downloadDeed(row.index)">
                      <b-spinner small v-if="row.item.isBusyDeed" label="Downloading..."></b-spinner>
                      <span v-else>Download</span>
                    </CButton>
                    <b-form-file
                      v-model="row.item.fileDeed"
                      accept=".pdf"
                      :ref="'document-upload-deed-' + row.index"
                      v-show="false"
                      @input="uploadDeed($event, row.index)"
                    ></b-form-file>
                  </template>
                  <template #cell(actionCert)="row">
                    <b-button class="mr-2" variant="primary" size="sm" style="width:63px" title="Upload Sertifikat" :disabled="row.item.isBusyCert || (details.contractStatus == 'RCE' && $helper.isRole($availRoles['Notaris']))" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['Notaris'])" @click="showUploadCertModal(row.index)">
                      <b-spinner v-if="row.item.isBusyCert" small label="Uploading..."></b-spinner>
                      <span v-else>Upload</span>
                    </b-button>
                    <CButton class="mr-2" color="primary" variant="outline" size="sm" style="width:81px" :title="$helper.isEmpty(row.item.certificateFiduciaFileId) ? 'Certificate unavailable' : 'Download Sertifikat'" :disabled="$helper.isEmpty(row.item.certificateFiduciaFileId) || row.item.isBusyCert" @click="downloadCertificate(row.index)">
                      <b-spinner small v-if="row.item.isBusyCert" label="Downloading..."></b-spinner>
                      <span v-else>Download</span>
                    </CButton>
                    <b-form-file
                      v-model="row.item.fileCert"
                      accept=".pdf"
                      :ref="'document-upload-cert-' + row.index"
                      v-show="false"
                      @input="uploadCertificate($event, row.index)"
                    ></b-form-file>
                  </template>
                  <template slot="empty">
                    <div v-if="!collateralTable.isLoaded" class="text-center">
                      <b-spinner label="Fetching Data..."></b-spinner>
                    </div> 
                    <div v-else class="text-center">
                      Tidak ada data
                    </div> 
                  </template>
                </b-table>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-3 offset-3 mt-4" v-if="isLoading">
        <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
      </CCol>
      <CCol class="col-3 mt-4" v-if="isLoading">
        <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
      </CCol>
      <CCol class="col-3 mt-4" v-if="isLoading">
        <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
      </CCol>
      <CCol class="col-12 mt-4" v-else>
        <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :title="details.documentStatus == 'Y' ? 'Document already validated' : ''" :disabled="validateData.isSubmitting || details.documentStatus == 'Y'" v-if="$helper.isRole($availRoles['Notaris'])" @click="validateDocument">
          <b-spinner small v-if="validateData.isSubmitting" />
          <span v-else>Validasi Dokumen</span>
        </b-btn>
        <b-btn variant="warning" class="float-right ml-3 mb-2 btn-sm custom-button-white" style="width:9rem" :disabled="false" v-if="$helper.isRole($availRoles['Notaris'])" @click="showNotesModal">
          <span>Note Dokumen</span>
        </b-btn>
        <b-btn variant="warning" class="float-right ml-3 mb-2 btn-sm custom-button-white" style="width:13rem" :disabled="details.certificateAvailable" :title="details.certificateAvailable ? 'Dokumen kontrak sudah tersedia' : ''" v-if="$helper.isEmpty(details.notaryName) && ($helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO']))" @click="showAssignModal">
          <span>Assign Kontrak Ke Notaris</span>
        </b-btn>
        <b-btn variant="warning" class="float-right ml-3 mb-2 btn-sm custom-button-white custom-button-disabled" style="width:13rem" :disabled="isAvailableCertificate || takeOverModalData.isSubmitting" :title="details.certificateAvailable ? 'Dokumen kontrak sudah tersedia' : ''" v-if="!$helper.isEmpty(details.notaryName) && ($helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO']))" @click="showTakeOverModal">
          <!-- <b-spinner small v-if="takeOverModalData.isSubmitting" /> -->
          <span>Take Over Kontrak Dari Notaris</span>
        </b-btn>
      </CCol>
    </CRow>
    <b-modal
      v-model="noteModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Note Dokumen Fiducia:"
              label-for="modal-fiducia-note"
              :state="noteModalData.documentNotes.isValid"
            >
              <b-form-textarea
                v-model="noteModalData.documentNotes.value"
                :state="noteModalData.documentNotes.isValid"
                placeholder="Note Dokumen Fiducia"
                id="modal-fiducia-note"
                rows="4"
                max-rows="4"
                maxlength="500"
              ></b-form-textarea>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow class="mt-1 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="noteModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="noteModalData.isSubmitting" @click="saveDocumentNotes">
              <b-spinner small v-if="noteModalData.isSubmitting" />
              <span v-else>Save</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
    <b-modal
      v-model="assignModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CForm>
        <CRow>
          <CCol class="col-12 mb-5">
            <b-form-group
              invalid-feedback="This input is required."
              label="Pilih Notaris"
              label-for="modal-notary-assign"
              :state="assignModalData.notary.isValid"
            >
              <multiselect 
                v-model="assignModalData.notary.value" 
                :options="assignModalData.notary.options" 
                :state="assignModalData.notary.isValid"
                :class="{custom_multiselect_invalid: assignModalData.notary.isValid === false}"
                :searchable="false"
                id="modal-notary-assign"
                placeholder="Select an option"
                :showLabels="false"
                openDirection="bottom"
                label="notaryName"
                track-by="mouId"
              >
                <template slot="singleLabel" slot-scope="props">{{ props.option.notaryName }}</template>
                <template slot="option" slot-scope="props">{{ props.option.notaryName }}</template>
                <template slot="noResult">No elements found.</template>
                <template slot="afterList" v-if="assignModalData.notary.currentPage < assignModalData.notary.totalPages">
                  <div class="text-center custom-cursor-clickable p-2" @click="appendSelectNotary" v-if="assignModalData.notary.isLoaded">
                    <span class="text-muted">Load More</span>
                  </div>
                  <div class="text-center" v-else>
                    <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                  </div>
                </template>
              </multiselect>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow class="mt-5 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="assignModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="assignModalData.isSubmitting" @click="assignContract">
              <b-spinner small v-if="assignModalData.isSubmitting" />
              <span v-else>Save</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
    <b-modal
      v-model="addDocumentModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Nama Dokumen:"
              label-for="form-document-name"
              :state="addDocumentModalData.document.name.isValid"
            >
              <b-form-input
                v-model="addDocumentModalData.document.name.value"
                :state="addDocumentModalData.document.name.isValid"
                placeholder="Nama Dokumen"
                id="form-document-name"
                maxlength="256"
              ></b-form-input>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Tipe File"
              label-for="form-document-type"
              :state="addDocumentModalData.document.type.isValid"
            >
              <multiselect 
                v-model="addDocumentModalData.document.type.value" 
                :options="addDocumentModalData.document.type.options" 
                :state="addDocumentModalData.document.type.isValid"
                :class="{custom_multiselect_invalid: addDocumentModalData.document.type.isValid === false}"
                :searchable="false"
                id="form-document-type"
                placeholder="Select an option"
                :showLabels="false"
                openDirection="bottom"
                label="text"
                track-by="text"
              >
                <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                <template slot="option" slot-scope="props">{{ props.option.text }}</template>
              </multiselect>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Kode Grup:"
              label-for="form-document-repo-group"
              :state="addDocumentModalData.document.repositoryGroup.isValid"
            >
              <b-form-input
                v-model="addDocumentModalData.document.repositoryGroup.value"
                :state="addDocumentModalData.document.repositoryGroup.isValid"
                placeholder="Kode Grup"
                id="form-document-repo-group"
                maxlength="10"
              ></b-form-input>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Kode Kategori:"
              label-for="form-document-repo-category"
              :state="addDocumentModalData.document.repositoryCategory.isValid"
            >
              <b-form-input
                v-model="addDocumentModalData.document.repositoryCategory.value"
                :state="addDocumentModalData.document.repositoryCategory.isValid"
                placeholder="Kode Kategori"
                id="form-document-repo-category"
                maxlength="10"
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow class="mt-1 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="addDocumentModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="addDocumentModalData.isSubmitting" @click="addDocument">
              <b-spinner small v-if="addDocumentModalData.isSubmitting" />
              <span v-else>Add</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
    <b-modal
      v-model="takeOverModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CRow>
        <CCol class="col-12">
          Apakah Anda yakin ingin Take Over Kontrak berikut dari Notaris?
        </CCol>
      </CRow>
      <CRow class="mt-2">
        <CCol class="col-6 col-xs-6 col-sm-5">
          No. Kontrak
        </CCol>
        <CCol class="col-6 col-xs-6 col-sm-7">
          : {{ $helper.showData(details.contractNo, "string") }}
        </CCol>
      </CRow>
      <CRow>
        <CCol class="col-6 col-xs-6 col-sm-5">
          Notaris
        </CCol>
        <CCol class="col-6 col-xs-6 col-sm-7">
          : {{ $helper.showData(details.notaryName, "string") }}
        </CCol>
      </CRow>
      <CRow class="mb-3">
        <CCol class="col-6 col-xs-6 col-sm-5">
          Tanggal Penugasan
        </CCol>
        <CCol class="col-6 col-xs-6 col-sm-7">
          : {{ $helper.showData(details.assignmentDate, "shortDate") }}
        </CCol>
      </CRow>
      <CRow class="mt-1 float-right">
        <CCol class="col-12">
          <b-btn variant="secondary" class="mr-3" @click="takeOverModalData.isShowing = false">Cancel</b-btn>
          <b-btn variant="primary" type="button" style="width:10rem" :disabled="isAvailableCertificate || takeOverModalData.isSubmitting" @click="takeOverContract">
            <b-spinner small v-if="takeOverModalData.isSubmitting" />
            <span v-else>Take Over Kontrak</span>
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal
      v-model="reGenerateDocumentModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CRow>
        <CCol class="col-12">
          Apakah Anda yakin ingin melakukan generate ulang dokumen pada kontrak ini?
        </CCol>
      </CRow>
      <CRow class="mt-1 float-right">
        <CCol class="col-12">
          <b-btn variant="secondary" class="mr-3" @click="reGenerateDocumentModalData.isShowing = false">Cancel</b-btn>
          <b-btn variant="primary" type="button" style="width:10rem" :disabled="reGenerateDocumentModalData.isSubmitting" @click="reGenerateDocument">
            <b-spinner small v-if="reGenerateDocumentModalData.isSubmitting" />
            <span v-else>Re-Generate</span>
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
  </CContainer>
</template>


<script>
export default {
  name: 'FiduciaDetail',
  data() {
    return {
      isLoading: true,
      details: {
        documentNotes: '',
        documentStatus: '',
        contractType: '',
        contractNo: '',
        officeCode: '',
        officeName: '',
        contractStatus: '',
        contractDate: '',
        notaryName: '',
        assignmentDate: '',
        customerName: '',
        customerAddress: '',
        customerDob: '',
        customerKtp: '',
        bussUnit: '',
        mouType: '',
        aktaAvailable: false,
        certificateAvailable: false,
        applNo: '',
        listDocument: []
      },
      collateralTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "customerBpkbName", label: "Nama BPKB", sortable: false},
          {key: "vehicleCategory", label: "Kategori Kendaraan", sortable: false},
          {key: "vehicleType", label: "Tipe Kendaraan", sortable: false},
          {key: "vehicleEngineNo", label: "Nomor Mesin", sortable: false},
          {key: "vehicleFrameNo", label: "Nomor Rangka", sortable: false},
          {key: "vehicleNopol", label: "Nomor Plat", sortable: false},
          {key: "vehicleColor", label: "Warna Kendaraan", sortable: false},
          { key: "actionDeed", label: "Akta", sortable: false, class: "custom-column-action-collateral"},
          { key: "actionCert", label: "Sertifikat", sortable: false, class: "custom-column-action-collateral"}
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      noteModalData: {
        isShowing: false,
        isSubmitting: false,
        documentNotes: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "notes"
        }
      },
      assignModalData: {
        isShowing: false,
        isSubmitting: false,
        notary: {
          /*
            "notaryCode": "string",
            "notaryName": "string",
            "mouId": "string
          */
          value: '',
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          payloadKey: "mouId"
        },
      },
      addDocumentModalData: {
        isShowing: false,
        isSubmitting: false,
        document: {
          name: {
            value: '',
            isValid: null,
            isRequired: true,
            payloadKey: "name"
          },
          repositoryGroup: {
            value: '',
            isValid: null,
            isRequired: true,
            payloadKey: "repoGroup"
          },
          repositoryCategory: {
            value: '',
            isValid: null,
            isRequired: true,
            payloadKey: "repoCategory"
          },
          type: {
            value: '',
            isValid: null,
            isRequired: true,
            options: [
              { value: "file", text: "File" },
              { value: "image", text: "Image" }
            ],
            payloadKey: "type"
          }
        }
      },
      takeOverModalData: {
        isShowing: false,
        isSubmitting: false,
        isSubmitted: false
      },
      validateData: {
        isSubmitting: false
      },
      reGenerateDocumentModalData: {
        isShowing: false,
        isSubmitting: false
      }
    }
  },
  methods: {
    onRowHover(idx){
      this.details.listDocument[idx].isHovered = true
    },
    onRowLeave(idx){
      this.details.listDocument[idx].isHovered = false
    },
    clearAddDocumentModalData(){
      this.addDocumentModalData.document.name.value = ''
      this.addDocumentModalData.document.repositoryGroup.value = ''
      this.addDocumentModalData.document.repositoryCategory.value = ''
      this.addDocumentModalData.document.type.value = ''
      this.addDocumentModalData.document.name.isValid = null
      this.addDocumentModalData.document.repositoryGroup.isValid = null
      this.addDocumentModalData.document.repositoryCategory.isValid = null
      this.addDocumentModalData.document.type.isValid = null
    },
    async getFiducia(contractId){
      this.isLoading = true
      let getUrl = "/contract/fiducia/getDetail"

      let params = {
        contractId: contractId
      }
      
      return await this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.details.documentNotes = response.data.data.documentNotes
          this.details.documentStatus = response.data.data.documentStatus
          this.details.contractType = response.data.data.contractType
          this.details.contractNo = response.data.data.contractNo
          this.details.officeCode = response.data.data.officeCode
          this.details.officeName = response.data.data.officeName
          this.details.contractStatus = response.data.data.contractStatus
          this.details.contractDate = response.data.data.contractDate
          this.details.notaryName = response.data.data.notaryName
          this.details.assignmentDate = response.data.data.assignmentDate
          this.details.customerName = response.data.data.customerName
          this.details.customerAddress = response.data.data.customerAddress
          this.details.customerDob = response.data.data.customerDob
          this.details.customerKtp = response.data.data.customerKtp
          this.details.bussUnit = response.data.data.bussUnit
          this.details.mouType = response.data.data.mouType
          this.details.aktaAvailable = response.data.data.aktaAvailable
          this.details.certificateAvailable = response.data.data.certificateAvailable
          this.details.applNo = response.data.data.applNo
          this.details.listDocument = response.data.data.listDocument.map(item => {
            let formattedExtension = item.extension.map(ext => {
              return "." + ext
            })
            let acceptedExtension = formattedExtension.join(", ")
            return {
              "id": item.id,
              "name": item.name,
              "repoGroup": item.repoGroup,
              "repoCategory": item.repoCategory,
              "repositoryId": item.repositoryId,
              "extension": item.extension,
              "extensionFile": item.extensionFile,
              "acceptedExtension": acceptedExtension,
              "fileUpload": null,
              "isTransferring": false,
              "isHovered": false
            }
          })
          return true
        }
        else{
          this.$helper.toastError(this, "Load Detail Fiducia Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Detail Fiducia Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Detail Fiducia Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    getCollateral(){
      this.collateralTable.isLoaded = false
      let getUrl = "/contract/fiducia/getCollateral"
      let params = {}
      params['contractId'] = this.$route.params.fiduciaId
      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.collateralTable.items = response.data.data.map(item => {
            item.isBusyDeed = false
            item.isBusyCert = false
            item.fileDeed = null
            item.fileCert = null
            return item
          })
        }
        else{
          this.$helper.toastError(this, "Load Detail Fiducia Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Detail Fiducia Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Detail Fiducia Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.collateralTable.isLoaded = true
      })
    },
    // populate select notary dropdown dynamically
    populateSelectNotary() {
      this.assignModalData.notary.isLoaded = false
      this.assignModalData.notary.totalPages = 0
      this.assignModalData.notary.totalRows = 0
      this.assignModalData.notary.currentPage = 1
      // URL builder
      let getUrl = "/mou/getMouToAssign"

      let params = this.$helper.getBasePagedQuery(this.assignModalData.notary.currentPage - 1, this.assignModalData.notary.perPage)
      params['bussUnit'] = this.details.bussUnit
      params['mouType'] = this.details.mouType
      params['officeCode'] = this.details.officeCode
      params['transType'] = this.details.contractType
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.assignModalData.notary.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.assignModalData.notary.options.push(response.data.data.data[i])
            }
            this.assignModalData.notary.totalRows = response.data.data.totalElements
            this.assignModalData.notary.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.assignModalData.notary.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // load more options for select notary dropdown dynamically
    appendSelectNotary() {
      this.assignModalData.notary.isLoaded = false
      // URL builder
      let getUrl = "/mou/getMouToAssign"
      
      let params = this.$helper.getBasePagedQuery(this.assignModalData.notary.currentPage, this.assignModalData.notary.perPage)
      params['bussUnit'] = this.details.bussUnit
      params['mouType'] = this.details.mouType
      params['officeCode'] = this.details.officeCode
      params['transType'] = this.details.contractType
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.assignModalData.notary.options.push(response.data.data.data[i])
            }
            this.assignModalData.notary.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.assignModalData.notary.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    showNotesModal(){
      this.noteModalData.documentNotes.value = this.details.documentNotes
      this.noteModalData.isShowing = true
    },
    showAssignModal(){
      this.assignModalData.notary.value = ''
      this.assignModalData.isShowing = true
    },
    showAddDocumentModal(){
      this.clearAddDocumentModalData()
      this.addDocumentModalData.isShowing = true
    },
    showReGenerateDocumentModal(){
      this.reGenerateDocumentModalData.isShowing = true
    },
    showTakeOverModal(){
      this.takeOverModalData.isShowing = true
    },
    saveDocumentNotes(event){
      event.preventDefault()
      let isFormValid = true
      let obj = {}
      if(!this.$helper.isEmpty(this.noteModalData.documentNotes.value)){
        this.noteModalData.documentNotes.isValid = null
        obj[this.noteModalData.documentNotes.payloadKey] = this.noteModalData.documentNotes.value
      }
      else if(this.noteModalData.documentNotes.isRequired){
        this.noteModalData.documentNotes.isValid = false
        isFormValid = false
      }
      else{
        this.noteModalData.documentNotes.isValid = null
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contractDocument/notes'
        obj["contractId"] = this.$route.params.fiduciaId
        obj["contractType"] = this.$route.params.fiduciaId.split("-")[1]
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Notaris'])){
          this.noteModalData.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Edit Note Kontrak Berhasil!")
              this.details.documentNotes = this.noteModalData.documentNotes.value
              this.noteModalData.isShowing = false
            }
            else{
              this.$helper.toastError(this, "Edit Note Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Edit Note Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Edit Note Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.noteModalData.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    assignContract(event){
      event.preventDefault()
      let isFormValid = true
      let payload = new FormData()
      if(!this.$helper.isEmpty(this.assignModalData.notary.value)){
        this.assignModalData.notary.isValid = null
        payload.append("mouId", this.assignModalData.notary.value.mouId)
      }
      else if(this.assignModalData.notary.isRequired){
        this.assignModalData.notary.isValid = false
        isFormValid = false
      }
      else{
        this.assignModalData.notary.isValid = null
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contract/fiducia/assign'
        payload.append("contractId", this.$route.params.fiduciaId)
        payload.append("contractType", this.$route.params.fiduciaId.split("-")[1])
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.assignModalData.isSubmitting = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.getFiducia(this.$route.params.fiduciaId)
              this.$helper.toastSuccess(this, "Assign Notaris Berhasil!")
              this.assignModalData.isShowing = false
            }
            else{
              this.$helper.toastError(this, "Assign Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Assign Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Assign Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.assignModalData.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    addDocument(event){
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.addDocumentModalData.document)){
        // check multiselect fields
        if(key == "type"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check remaining fields
        else{
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
      }
      // submit form data if every field is valid
      if(isFormValid){
        obj["contractId"] = this.$route.params.fiduciaId
        obj["contractType"] = this.$route.params.fiduciaId.split("-")[1]
        let postUrl = '/contractDocument/add'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.addDocumentModalData.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Create Dokumen Berhasil!")
              this.addDocumentModalData.isShowing = false
              this.getFiducia(this.$route.params.fiduciaId)
            }
            else{
              this.$helper.toastError(this, "Create Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Create Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.addDocumentModalData.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    deleteDocument(idx){
      let payload = new FormData()
      payload.append("id", this.details.listDocument[idx].id)
      let postUrl = '/contractDocument/delete'
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        this.details.listDocument[idx].isTransferring = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Delete Dokumen Berhasil!")
            this.getFiducia(this.$route.params.fiduciaId)
          }
          else{
            this.$helper.toastError(this, "Delete Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Delete Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Delete Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.details.listDocument[idx].isTransferring = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    takeOverContract(){
      let payload = new FormData()
      let postUrl = '/contract/fiducia/takeOver'
      payload.append("contractId", this.$route.params.fiduciaId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.takeOverModalData.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.takeOverModalData.isShowing = false
            this.getFiducia(this.$route.params.fiduciaId)
            this.$helper.toastSuccess(this, "Take Over Kontrak Berhasil!")
          }
          else{
            this.$helper.toastError(this, "Take Over Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Take Over Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Take Over Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.takeOverModalData.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    reGenerateDocument(){
      let payload = new FormData()
      let postUrl = '/contractDocument/regenerate'
      payload.append("applNo", this.details.applNo)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Cabang'])){
        this.reGenerateDocumentModalData.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.reGenerateDocumentModalData.isShowing = false
            this.$helper.toastSuccess(this, "Generate Ulang Dokumen Berhasil!")
          }
          else{
            this.$helper.toastError(this, "Generate Ulang Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Generate Ulang Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Generate Ulang Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.reGenerateDocumentModalData.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    validateDocument(){
      let payload = new FormData()
      let postUrl = '/contractDocument/validate'
      payload.append("contractId", this.$route.params.fiduciaId)
      payload.append("contractType", this.$route.params.fiduciaId.split("-")[1])
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Notaris'])){
        this.validateData.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.getFiducia(this.$route.params.fiduciaId)
            this.$helper.toastSuccess(this, "Validasi Kontrak Berhasil!")
          }
          else{
            this.$helper.toastError(this, "Validasi Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Validasi Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Validasi Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.validateData.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    showUploadCertModal(idx) {
      this.$refs['document-upload-cert-' + idx].$el.childNodes[0].click()
    },
    showUploadDeedModal(idx) {
      this.$refs['document-upload-deed-' + idx].$el.childNodes[0].click()
    },
    showUploadModal(idx) {
      this.$refs['document-upload-' + idx][0].$el.childNodes[0].click()
    },
    uploadCertificate(file, idx) {
      let isFormValid = true
      let payload = new FormData()
      if(this.$helper.isEmpty(file)){
        isFormValid = false
        return
      }
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contract/fiducia/uploadCertificate'
        payload.append("collateralId", this.collateralTable.items[idx].id)
        payload.append("file", file)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
          this.collateralTable.items[idx].isBusyCert = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.details.contractStatus = response.data.data.status
              this.getCollateral()
              this.$helper.toastSuccess(this, "Upload Sertifikat Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Sertifikat Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Upload Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Upload Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.collateralTable.items[idx].fileCert = null
            this.collateralTable.items[idx].isBusyCert = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    downloadCertificate(idx) {
      let payload = new FormData()
      let postUrl = '/contract/fiducia/downloadCertificate'
      payload.append("collateralId", this.collateralTable.items[idx].id)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.collateralTable.items[idx].isBusyCert = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.$route.params.fiduciaId + "-" + this.collateralTable.items[idx].id + "-cert.pdf"
            link.click()
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.collateralTable.items[idx].isBusyCert = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    uploadDeed(file, idx){
      let isFormValid = true
      let payload = new FormData()
      if(this.$helper.isEmpty(file)){
        isFormValid = false
        return
      }
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contract/fiducia/uploadAkta'
        payload.append("collateralId", this.collateralTable.items[idx].id)
        payload.append("file", file)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
          this.collateralTable.items[idx].isBusyDeed = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.getCollateral()
              this.$helper.toastSuccess(this, "Upload Akta Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Akta Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Upload Akta Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Upload Akta Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.collateralTable.items[idx].fileDeed = null
            this.collateralTable.items[idx].isBusyDeed = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    downloadDeed(idx) {
      let payload = new FormData()
      let postUrl = '/contract/fiducia/downloadAkta'
      payload.append("collateralId", this.collateralTable.items[idx].id)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.collateralTable.items[idx].isBusyDeed = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.$route.params.fiduciaId + "-" + this.collateralTable.items[idx].id + "-deed.pdf"
            link.click()
          }
          else{
            this.$helper.toastError(this, "Download Akta Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Akta Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Akta Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.collateralTable.items[idx].isBusyDeed = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    uploadDocument(file, idx){
      let isFormValid = true
      let payload = new FormData()
      if(this.$helper.isEmpty(file)){
        isFormValid = false
        return
      }
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contractDocument/uploadDocFiducia'
        let allowedExtension = this.details.listDocument[idx].extension
        let fileNameSplit = file.name.split(".")
        let fileExt = fileNameSplit[fileNameSplit.length-1]
        payload.append("repoCategory", this.details.listDocument[idx].repoCategory)
        payload.append("repoGroup", this.details.listDocument[idx].repoGroup)
        payload.append("contractId", this.$route.params.fiduciaId)
        payload.append("allowedExtension", JSON.stringify(allowedExtension))
        payload.append("extension", fileExt)
        payload.append("file", file)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.details.listDocument[idx].isTransferring = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.details.listDocument[idx].repositoryId = response.data.data
              this.details.listDocument[idx].extensionFile = fileExt
              this.$helper.toastSuccess(this, "Upload Dokumen Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Upload Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Upload Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.details.listDocument[idx].fileUpload = null
            this.details.listDocument[idx].isTransferring = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    downloadDocument(idx) {
      let payload = new FormData()
      let postUrl = '/contractDocument/download/byte'
      payload.append("repositoryId", this.details.listDocument[idx].repositoryId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.details.listDocument[idx].isTransferring = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.details.listDocument[idx].repositoryId + "." + this.details.listDocument[idx].extensionFile
            link.click()
          }
          else{
            this.$helper.toastError(this, "Download Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.details.listDocument[idx].isTransferring = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
    isAvailableCertificate() {
      return (this.details.contractStatus == 'WFA' || this.details.contractStatus == 'RCE')
    },
  },
  async mounted() {

  },
  async created(){
    let success = await this.getFiducia(this.$route.params.fiduciaId)
    if(success){
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.populateSelectNotary()        
      }
      this.getCollateral()
    }
    // this.getFiducia(this.$route.params.fiduciaId).then(() => {
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.populateSelectNotary()
    //   }
    // })
    // this.getCollateral()
  }
}
</script>

<style scoped>
.btn.custom-button-disabled:disabled{
  cursor: default !important;
}
</style>
